<template>
  <div>
    <b-row>
      <b-colxx>
        <b-card class="mb-4">

          <b-row>
            <b-colxx xxs="12" md="4" lg="3" xl="3" class="pr-0" v-if="userRole==='BRAND_ADMIN'">
              <div class="form-group has-float-label">
                <v-select v-model="storeSearchKind" label="label" :options="storeSelectOption"/>
                <span>매장선택</span>
              </div>
            </b-colxx>
            <b-colxx xxs="12" md="4" lg="3" xl="3" class="pr-0">
              <div class="form-group has-float-label">
                <v-select v-model="searchKind" :reduce="item=>item.value" label="label" :options="searchOption"/>
                <span>검색유형</span>
              </div>
            </b-colxx>

            <b-colxx xxs="12" md="6" lg="4" xl="4">
              <b-input-group>
                <b-input class="" v-model="searchKeyword" :placeholder="searchPlaceholder" @keyup.enter="onSearch"/>
                <!-- <b-button variant="outline-primary" v-if="!searchFlag" @click="onSearch">조회</b-button> -->
                <b-input-group-append>
                  <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default">
                    {{ $t('button.search') }}
                  </b-button>
                </b-input-group-append>
                <b-button variant="outline-primary" v-if="searchFlag" @click="searchCancel">취소</b-button>

              </b-input-group>
            </b-colxx>

          </b-row>
          <b-row>
            <b-colxx class="float-right" xxs="12" md="12" xs="12">
              <div class="float-md-right pt-1 mb-2">
                <b-button class="float-right" variant="primary" @click="useMobileCoupon">사용처리</b-button>
              </div>
            </b-colxx>
          </b-row>


          <b-row>
            <b-colxx xxs="12">
              <b-table-simple head-variant="light"
                              ref="general-table"
                              class="vuetable"
                              id="table-transition-example"
              >
                <b-thead head-variant="light">
                  <b-tr>
                    <template v-for="(field , idx) in fields">
                      <b-th style="text-align: center">{{ field.label }}</b-th>
                    </template>
                    <b-th style="text-align: center">
                      <b-form-checkbox v-model="allCheck" :checked="true" :unchecked-value="false "></b-form-checkbox>
                    </b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>


                  <!-- 주문,상품 -->
                  <template v-for="(item , i ) in items">
                    <b-tr>
                      <b-td v-bind:rowspan="item.coupons.length + 1 " style="text-align: center">
                        {{ item.key }}
                      </b-td>
                      <b-td v-bind:rowspan="item.coupons.length + 1 " style="text-align: center">
                        {{ item.buyerName }}
                      </b-td>
                      <b-td v-bind:rowspan="item.coupons.length + 1 " style="text-align: center">
                        {{
                          item.buyerPhone.length == 11 ? '*****' + item.buyerPhone.substr(5, item.buyerPhone.length) : '****' + item.buyerPhone.substr(5, item.buyerPhone.length)
                        }}
                      </b-td>
                      <b-td  v-bind:rowspan="item.coupons.length + 1 " style="text-align: center">
                          <div>
                            {{item.selfSales == true? 'Y' : ''}}
                          </div>
                      </b-td>
                      <b-td v-bind:rowspan="item.coupons.length + 1 " style="text-align: center">
                        <div>
                          {{ item.coupons[0].goodsName }}
                        </div>
                        <div style="color: #909090; text-decoration: underline"
                             v-b-tooltip.hover="{ variant: 'info'}" :title="item.coupons[0].goodsTag"
                             v-if='item.coupons[0].goodsTag != null && item.coupons[0].goodsTag !== ""'>
                          {{ goodsTagEllipse(item.coupons[0].goodsTag) }}
                        </div>
                      </b-td>
                    </b-tr>

                    <!-- 옵션 -->
                    <template v-for="(coupon , idx) in item.coupons">
                      <b-tr>
                        <b-td style="text-align: center">{{ coupon.optionName }}</b-td>
                        <b-td style="text-align: center">{{ coupon.itemNo }}</b-td>
                        <b-td style="text-align: center">
                          {{
                            coupon.availableTo >= toDay ? coupon.availableTo.substr(0, 10) + " " + coupon.availableTo.substr(11, 8) : "만료"
                          }}
                        </b-td>
                        <!-- 사용일 -->
                        <b-td style="text-align: center">

                          <!--잔액버튼(금액권) -->
                          <template v-if="coupon.goodsType === 'MoneyCoupon'">
                            <b-button variant="primary" @click="ModalShowCoupon(coupon.goodsType , coupon)" size="sm">
                              잔액 : {{ coupon.usableAmount|currency }}
                            </b-button>
                          </template>

                          <!--사용날짜버튼 -->
                          <template v-else>
                            <template v-if="coupon.consumedDate">
                              <h3>
                                <b-button variant="primary" @click="ModalShowCoupon(coupon.goodsType , coupon)"
                                          size="sm" v-b-popover.hover.top="'사용내역조회'">
                                  {{ coupon.consumedDate.substr(0, 10) }}<!--<br/>{{coupon.use_store}}-->
                                </b-button>
                              </h3>
                            </template>
                          </template>
                        </b-td>

                        <!-- 체크박스 -->
                        <b-td style="text-align: center">

                          <!--사용버튼(금액권) -->
                          <!--                          <template v-if="coupon.goodsType === 'MoneyCoupon'">-->
                          <!--                            <b-button v-if="coupon.usableAmount > 0&&coupon.itemStatus == 'Available' "-->
                          <!--                                      variant="primary" size="sm"-->
                          <!--                                      @click="ModalShowAmount(coupon)">사용-->
                          <!--                            </b-button>-->
                          <!--                          </template>-->

                          <!--체크박스 -->
                          <template>
                            <!-- <template v-if="(new Date(coupon.availableTo) > new Date())&& !coupon.consumedDate">
                              <b-form-checkbox v-model="coupon.selected" :checked="true"
                                               :unchecked-value="false"></b-form-checkbox>
                            </template> -->
                            <template
                              v-if="(new Date(coupon.availableTo).setHours(new Date(coupon.availableTo).getHours() + 15) > new Date()) && !coupon.consumedDate && coupon.goodsType !== 'MoneyCoupon'">
                              <b-form-checkbox v-model="coupon.selected" :checked="true"
                                               :unchecked-value="false"></b-form-checkbox>
                            </template>
                            <template
                              v-if="coupon.goodsType === 'MoneyCoupon' && coupon.usableAmount > 0 &&coupon.itemStatus == 'Available' ">
                              <b-form-checkbox v-model="coupon.selected" :checked="true"
                                               :unchecked-value="false"></b-form-checkbox>
                            </template>
                          </template>


                        </b-td>
                      </b-tr>
                    </template>
                    <!-- 옵션 end -->

                  </template>
                </b-tbody>
              </b-table-simple>

              <b-pagination
                v-if="lastPage > 1"
                size="sm"
                align="center"
                :total-rows="total"
                :per-page="perPage"
                v-model="currentPage"
              >
                <template v-slot:next-text>
                  <i class="simple-icon-arrow-right"/>
                </template>
                <template v-slot:prev-text>
                  <i class="simple-icon-arrow-left"/>
                </template>
                <template v-slot:first-text>
                  <i class="simple-icon-control-start"/>
                </template>
                <template v-slot:last-text>
                  <i class="simple-icon-control-end"/>
                </template>
              </b-pagination>

            </b-colxx>
          </b-row>

          <!-- 사용내역조회 모달 -->
          <coupon-use-detail ref="modal_coupon_detail" :data="selectedCouponHistory" :goodsType="selectedGoodsType"
                             @process="couponCancel"/>

          <!-- 금액권 사용처리 모달 -->
          <amount-use-detail ref="modal_amount_use_detail" :selectedBalance="selectedBalance" @process="useAmount"/>

        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapMutations
} from "vuex";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {alignTableCenter, currencyFilter} from "../../utils";
import api from '../../constants/api'
import CouponUseDetail from "../../views/coupon/components/CouponUseDetail";
import AmountUseDetail from "../../views/coupon/components/AmountUseDetail";


export default {
  name: 'CouponModal',
  components: {
    'v-select': vSelect,
    'coupon-use-detail': CouponUseDetail,
    'amount-use-detail': AmountUseDetail
  },
  props: ['data'],
  filters: {...currencyFilter},


  data() {

    return {
      toDay: this.$moment().format("YYYY-MM-DD"),
      searchValue: {
        startDate: null,
        endDate: null,
      },
      searchKind: 'PhoneNumber4',
      storeSearchKind:'매장을 선택해주세요',
      selectStoreCode: null,
      searchKeyword: null,
      isLoad: false,
      allCheck: false,
      currentPage: 1,
      perPage: 20,
      lastPage: 0,
      total: 0,
      searchFlag: false,
      userRole:null,
      searchOption: [
        {label: "전화번호 뒷 4자리", value: "PhoneNumber4"},
        {label: "전화번호", value: "PhoneNumber"},
        {label: "쿠폰번호", value: "ItemNo"}
      ],
      storeSelectOption: [],
      searchPlaceholder: '전화번호 뒷 4자리를 입력해 주세요.',
      selectedGoodsType: null, //선택된쿠폰타입
      selectedCouponHistory: [], //쿠폰 히스토리
      selectedCouponItemNo: '', // 선택된쿠폰번호
      selectedBalance: null, //선택된 잔액
      fields: [
        {key: 'key', label: "번호", ...alignTableCenter},
        {key: 'buyer', label: "구매자", ...alignTableCenter},
        {key: 'phone', label: "전화번호", ...alignTableCenter},
        {key: 'selfSales', label: "자체판매", ...alignTableCenter},
        {key: 'goods_name', label: "상품명", ...alignTableCenter},
        {key: 'option_name', label: "옵션명", ...alignTableCenter},
        {key: 'coupon_serial', label: "쿠폰번호", ...alignTableCenter},
        {key: 'expire_date', label: "유효기간", ...alignTableCenter},
        {key: 'use_date', label: "사용일", ...alignTableCenter},
      ],
      items: [],
      newOrderArr: [],
      smAmount: [],
      defaultStoreCode:null
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName'])
  },



  created(){
    this.userRole = JSON.parse(sessionStorage.getItem('BRAND_USER_INFO')).userRole;
    if(this.userRole === 'BRAND_ADMIN'){
      this.getStoreList();
    }
  },


  mounted() {
    this.allCheck = false;
    this.searchKeyword = this.data
    if (this.searchKeyword != '') {
      this.searchData()
    }
  },


  watch: {

    searchKind(selectObj) {
      if (selectObj == "ItemNo") {
        this.searchPlaceholder = "쿠폰번호 12자리를 입력해 주세요."

      } else if (selectObj == "PhoneNumber") {
        this.searchPlaceholder = "전화번호를 입력해 주세요."
      } else {
        this.searchPlaceholder = "전화번호 뒷 4자리를 입력해 주세요."
      }
    },

    currentPage(value) {
      this.searchData();
    },

    allCheck(chk) {
      this.items.forEach((v) => {
        v.coupons.forEach((vv) => {
          vv.selected = chk
        })
      })
    },
  },


  methods: {
    goodsTagEllipse(goodsTag) {
      let length = 25;
      goodsTag = "(" + goodsTag + ")";

      if (goodsTag.length > length) {
        return goodsTag.substr(0, length - 2) + '...';
      } else {
        return goodsTag;
      }
    },
    getStoreList(){

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeList)

      this.$http.get(reqURL, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          res.data.data.forEach(data =>{
            if(data.enabled){
              this.storeSelectOption.push(
                {label:data.storeName, value:data.storeCode}
              );
            }
          });
          this.storeSearchKind = this.storeSelectOption[0].label;
          this.defaultStoreCode = this.storeSelectOption[0].value;
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })


    },
    //리스트 조회
    searchData() {
      setTimeout(()=> {

        let storeCode = null;

        if (this.selectStoreCode == null) {
          storeCode = this.defaultStoreCode;

        } else {
          storeCode = this.selectStoreCode;
        }
        this.isLoad = false
        this.items = []

        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.couponList)

        const params = {
          dateFrom: this.searchValue.startDate,
          dateTo: this.searchValue.endDate,
          pageNumber: this.currentPage - 1,
          pageSize: this.perPage,
          keywordType: this.searchKind,
          keyword: this.searchKeyword,
          storeCode: storeCode
        }

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {
            //
            let _data = res.data.data
            this.items = _data
            this.items.forEach((v) => {
              Object.assign(v, {coupons: null})
              v.coupons = v.orderItems.filter(item => item.itemStatus == 'Available' || item.itemStatus == 'Consumed')
            })
            this.items = this.items.filter(item => item.coupons.length > 0)
            for (let i = 0; i < this.items.length; i++) {
              this.items[i].key = i + 1
            }


            this.isLoad = true

          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      },100);
    },

    //조회버튼클릭
    onSearch() {
      if(this.userRole ==='BRAND_ADMIN'){
        if(this.storeSearchKind.value!==null || this.storeSearchKind.value !== undefined) {
          this.selectStoreCode = this.storeSearchKind.value;
        }
        this.storeSelectOption.forEach(list=>{
          if(list.label === this.storeSearchKind){
            this.selectStoreCode = list.value;
          }
        });


      }
      if (this.searchKeyword === null || this.searchKeyword === "") {
        alert('검색어를 입력해주세요')
        return false
      } else {
        // this.searchFlag = true;
        this.searchData()
      }
    },

    searchCancel() {
      this.searchKeyword = null;
      this.searchFlag = false;
      this.searchData()
    },

    //금액권 사용처리 모달열기
    ModalShowAmount(coupon) {
      var data = this.selectUseCoupon();


      //주문별 유효기간 체크 후 재정렬 작은 날짜부터 오름차순으로 정렬
      data.orders.sort(function (a, b) {
        return new Date(a.availableToArr).getTime() - new Date(b.availableToArr).getTime();
      });

      //금액별 오름차순으로 정렬
      this.smAmount = data.orders.sort(function (a, b) {
        return a.arrFirstAmount - b.arrFirstAmount;
      });

      // 유효기간 , 금액별 체크한 새로운 배열을 생성한다. 사용처리를 위한 실사용 배열
      this.newOrderArr = [];
      for (const idx in this.smAmount) {
        for (const idxs in this.smAmount[idx].mobileMoney) {
          this.newOrderArr.push(this.smAmount[idx].mobileMoney[idxs]);
        }
      }

      this.newOrderArr.sort((a, b) => {
        if (a.useAmount === b.useAmount) {
          return new Date(a.availableTo).getTime() - new Date(b.availableTo).getTime();
        }
      });

      //금액별 오름차순으로 정렬
      this.newOrderArr.sort(function (a, b) {
        return a.useAmount - b.useAmount;
      });

      console.log(this.newOrderArr)
      // console.log(this.smAmount)
      let newOrderUsableAmountArr = null;
      let newOrderItemNosArr = [];
      // 자식 컴포넌트에서 넘겨야하는 값 생성
      for (const idx in this.newOrderArr) {
        newOrderUsableAmountArr += Number(this.newOrderArr[idx].useAmount);
        newOrderItemNosArr.push(this.newOrderArr[idx].itemNo)
      }
      // 배열의 모든 사용가능한 금액 합산 값을 담는다.
      this.selectedBalance = newOrderUsableAmountArr;
      // 주문별 아이템 넘버를 담는다.
      this.selectedCouponItemNo = newOrderItemNosArr

      this.$refs.modal_amount_use_detail.open()
    },


    //금액권 사용처리
    useAmount(item) {
      let userUseAmount = JSON.parse(JSON.stringify(item)); // 사용자가 입력한 사용할 금액
      let userUseAmountSingle = JSON.parse(JSON.stringify(item));// 변하지 않게 깊은 복사로 값을 보존 하여 백엔드에 넘긴다.
      let newOrderArrCopy = JSON.parse(JSON.stringify(this.newOrderArr));

      let setOrderArr = [];
      let getItemsArr = [];// 재가공을 위한 배열(아이템즈 별로 있는걸 개별로 분리 하기위한 배열)
      let orderNo = []; // orderNo 를 따로 보존하여 새로운 배열에 넣기위한 배열
      let itemUseAmount = 0;// 아이템에 사용가능한 금액

      for (const idx in newOrderArrCopy) {
        let userUseAmountCopy = 0;

        itemUseAmount = Number(newOrderArrCopy[idx].useAmount);
        userUseAmount = userUseAmount - itemUseAmount; // if 문에서 사용할 변수

        if (newOrderArrCopy.length === 1) {
          newOrderArrCopy[idx].useAmount = userUseAmountSingle;
          orderNo.push(newOrderArrCopy[idx].orderNo)
          getItemsArr.push(
            newOrderArrCopy[idx]
          )
        } else {
          if (userUseAmount > 0) {// 마지막 배열이 아닌경우 쿠폰에 사용금액이 전체 차감 된다. 양수일경우
            newOrderArrCopy[idx].useAmount = itemUseAmount;
            orderNo.push(newOrderArrCopy[idx].orderNo);
            getItemsArr.push(
              newOrderArrCopy[idx]
            )
          } else { // 음수일 경우 마지막 값 유저가 적은 값 - 쿠폰 사용가능금액을 넣어줌으로 차감시킴
            newOrderArrCopy[idx].useAmount = itemUseAmount - Math.abs(userUseAmount);
            orderNo.push(this.newOrderArr[idx].orderNo)
            getItemsArr.push(
              newOrderArrCopy[idx]
            )
            break;
          }
        }

      }

      // console.log(this.newOrderArr);
      // console.log(getItemsArr);


      // 배열을 다시 오더넘버로 합쳐 주기 위한 새로운 배열 생성
      let newsetorderno = [...new Set(orderNo)];
      let newsetordernoChange = [];
      for (const newsetordernoKey in newsetorderno) {
        newsetordernoChange.push({
          items: [],
          orderNo: newsetorderno[newsetordernoKey]
        })
      }


      // 오더 넘버 기준으로 다시 배열을 합쳐준다.
      for (const idxbn in newsetordernoChange) {
        for (const idxv in getItemsArr) {
          if (getItemsArr[idxv].orderNo === newsetordernoChange[idxbn].orderNo) {
            newsetordernoChange[idxbn].items.push(getItemsArr[idxv])
          }
        }
      }
      setOrderArr = newsetordernoChange;

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.useMoneyCoupon)

      const params =
        {
          memo: "금액권 사용 처리함",
          // orderNo: orderNo,
          // itemNo: itemNo,
          // useAmount: item,
          currencyCode: "KRW",
          orders: setOrderArr,
          storeCode: this.selectStoreCode
          // useTotalAmount: userUseAmountParm,
        }


      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          //
          this.$refs.modal_amount_use_detail.modalHide()
          this.searchData()

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },


    //쿠폰사용처리
    useMobileCoupon() {

      var data = this.selectUseCoupon();
      let selected = data.selected        //체크여부
      let count = data.count              //체크갯수
      let type = data.type                //선택한쿠폰들 GoodsType
      let couponGoodsType = data.type[0]  //선택한 쿠폰 GoodsType
      let typeErrFlag = false;
      let moneyCouponTypeErrFlag = false;
      const orders = data.orders         //체크된 옵션의 orderNo, itemNo[]
      console.log(orders)

      //선택한 쿠폰중 다른타입의 쿠폰종류가 섞여있는지 체크
      type.forEach(val => {
        if (val != couponGoodsType) {
          typeErrFlag = true
        }
        if (type.includes('MoneyCoupon')) {
          if (val != "MoneyCoupon") {
            moneyCouponTypeErrFlag = true;
          }
        }
      })

      let receiverPhoneArr = [];
      for (const idx in data.orders) {
        if (data.orders[idx].receiverPhone.length > 1) {
          for (const idx2 in data.orders[idx].receiverPhone) {
            receiverPhoneArr.push(data.orders[idx].receiverPhone[idx2]);
          }
        } else {
          receiverPhoneArr.push(...data.orders[idx].receiverPhone);
        }
      }

      const setReceiverPhoneArr = [...new Set(receiverPhoneArr)];
      // console.log(setReceiverPhoneArr)

      if (count < 1) {
        alert("쿠폰은 한개 이상 선택하셔야합니다.");
        return
      }
      // if (moneyCouponTypeErrFlag === true) {
      //   alert("금액권은 다른 상품유형의 쿠폰과 함께 사용처리가 불가합니다.")
      //   return
      // }
      if (typeErrFlag == true) {
        alert("사용처리하려는 쿠폰의 종류가 다릅니다.")
        return
      }
      if (setReceiverPhoneArr.size > 1 && type.includes('MoneyCoupon') || setReceiverPhoneArr.length > 1 && type.includes('MoneyCoupon')) {
        alert('서로 다른 수신자의 쿠폰은 함께 사용처리가 불가합니다.');
        return;

      }
      if (orders == null) {
        alert("주문번호,아이템번호가 없습니다.");
        return
      }

      if (confirm(count + '개가 선택되었습니다. 사용처리 하시겠습니까?')) {

        if (couponGoodsType == "MoneyCoupon") {
          this.ModalShowAmount();
          return;
        }

        if (couponGoodsType == "MobileCoupon") {
          var reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.consumeMobileCoupons)
        }

        if (couponGoodsType == "BookingCoupon") {
          var reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.consumeBookingCoupons)
        }

        let storeCode = null;

        if (this.selectStoreCode == null) {
          storeCode = this.defaultStoreCode;

        } else {
          storeCode = this.selectStoreCode;
        }


        const params =
          {
            "memo": "사용 처리 함",
            "orders": orders,
             "storeCode": storeCode
          }

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {
            //
            this.$refs.modal_amount_use_detail.modalHide()
            this.searchData()


          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      }
    },


    selectUseCoupon() {

      let data = {}
      let selected = false
      let count = 0
      let type = []

      const orders = []

      this.items.forEach((v) => {
          let flag = false;
          const orderNo = v.orderNo //주문번호
          let itemNoArr = []
          let usableAmountArr = [];
          let availableToArr = '';
          let mobileMoneyArr = [];
          let usedAmountSum = 0;
          let receiverPhone = [];

          v.coupons.forEach(function (value, index) {
            if (value.itemStatus == "Available") {
              if (value.selected) {
                flag = true
                itemNoArr.push(value.itemNo)
                count++
                selected = true
                type.push(value.goodsType);
                usableAmountArr.push(value.usableAmount);
                receiverPhone.push(value.receiverPhone);
                availableToArr = value.availableTo;
                mobileMoneyArr.push({
                  "orderNo": orderNo,
                  "itemNo": value.itemNo,
                  'useAmount': value.usableAmount,
                  'availableTo': value.availableTo,
                })
                usedAmountSum += Number(value.usableAmount)
              }
            }
          })

          const smAmount = mobileMoneyArr.sort(function (a, b) {
            return a.useAmount - b.useAmount;
          });

          if (flag) {
            orders.push({
              "orderNo": orderNo,
              "itemNos": itemNoArr,
              "mobileMoney": mobileMoneyArr,
              "usableAmount": usableAmountArr.sort((a, b) => a < b ? -1 : 1),
              "arrFirstAmount": usableAmountArr.sort((a, b) => a < b ? -1 : 1)[0],
              // "availableTo": smAmount,
              "usedAmountSum": usedAmountSum,
              "receiverPhone": receiverPhone,
              "availableToArr": availableToArr,
            })
          }
        }
      )

      data.selected = selected
      data.count = count
      data.orders = orders
      data.type = type

      return data
    },


    //사용내역 모달열기
    ModalShowCoupon(goodsType, coupon) {
      this.selectedCouponHistory = []
      this.selectedGoodsType = goodsType

      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.itemUseInfo)
      const params =
        {"itemNo": coupon.itemNo}

      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          this.ModalShowCouponCallback(goodsType, res.data.data)
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },


    ModalShowCouponCallback(goodsType, data) {
      let couponHistory = []
      const transactions = data.transactions
      transactions.forEach((v, index) => {
        if (!v.cancelled) {
          const chistory = {
            id: index + 1,
            item_no: data.itemNo,
            transaction_no: v.transactionNo,
            use_date: v.useDate.substr(0, 10) + " " + v.useDate.substr(11, 5),
            use_store: v.storeName,
            manager: v.managerId
          }


          const now = this.$moment(new Date()).toDate()
          const useDate = this.$moment(v.use_date).toDate()

          const newMonth = this.$moment(new Date()).toDate().getDay() - 1
          const useDateMonth = this.$moment(new Date()).toDate().getDay() - 1

          if (goodsType == "MoneyCoupon") { //금액권
            chistory.use_amount = v.useAmount

            if (now.getDate() != useDate.getDate()) {
              //당일이 아닌경우 취소불가
              chistory.cancellable = false
            }

          } else { //쿠폰

            var cancelDate = useDate.setDate(useDate.getDate() + 5)
            if (now > cancelDate) {
              //5일경과시 취소불가
              chistory.cancellable = false
            }
          }


          if (newMonth != useDateMonth) {
            chistory.cancellable = false
          }

          couponHistory.push(chistory)
        }
      })

      this.selectedCouponHistory = couponHistory

      if (Object.entries(couponHistory).length === 0) {
        return;
      }
      this.$refs.modal_coupon_detail.open()

    },


    //쿠폰 사용처리 취소
    couponCancel(data) {
      let arr = [];


      const cancelUsed = data.cancelUsed;

      cancelUsed.forEach(function (value, index) {
        if (value.selected) {
          const transaction =
            {
              "itemNo": value.item_no,
              "transactionNo": value.transaction_no
            }
          arr.push(transaction)
        }
      })
      //  배열 비었는지 체크
      if (arr.length < 1) {
        alert("쿠폰번호 , 트랜젝션 번호가 없습니다.")
        return
      }
      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.cancelItemUseTransaction)

      const params = {
        "memo": "고객 요청에 의한 처리",
        "transactions": arr
      }

      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          //
          this.$refs.modal_coupon_detail.modalHide("CouponUseDetail")
          this.$refs.modal_coupon_detail.modalHide("cancelReason")
          this.searchData()
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })


    },
  }
}
</script>

<style scoped>
.tooltip {
  top: 0;
}
</style>
